// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7366":"ea0621d0","8687":"b60c9472"}[chunkId] + ".chunk.css";
};